<template>
  <div class="page-inform">

    <img src="../assets/common/inform.png" class="inform-img" alt="">

    <!-- <lwzx-concat></lwzx-concat> -->
  </div>
</template>
<script>
// import LWZXConcat from '@/components/Concat'
export default {
  components: {
    // 'lwzx-concat': LWZXConcat
  }
}
</script>
